export const API_ENDPOINTS = {
  login: '/vendors-tracking/auth/login',
  healthz: '/vendors-tracking/healthz',
  vendors: '/vendors-tracking/vendors',
  summary: '/vendors-tracking/summary',
  breakdown: '/vendors-tracking/breakdown',
  events: '/vendors-tracking/events',
  exportReport: '/vendors-tracking/reports/export',
};
